"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiningRobotsManufCenter = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var MoonCard_1 = require("./MoonCard");
var MiningRobotsManufCenter = (function (_super) {
    __extends(MiningRobotsManufCenter, _super);
    function MiningRobotsManufCenter() {
        return _super.call(this, {
            name: CardName_1.CardName.MINING_ROBOTS_MANUF_CENTER,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 12,
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
            tr: { moonMining: 2 },
            metadata: {
                description: 'Spend 1 titanium. Raise the Mining Rate 2 steps.',
                cardNumber: 'M23',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().titanium(1).br;
                    b.moonMiningRate({ amount: 2 });
                }),
            },
        }) || this;
    }
    MiningRobotsManufCenter.prototype.play = function (player) {
        _super.prototype.play.call(this, player);
        MoonExpansion_1.MoonExpansion.raiseMiningRate(player, 2);
        return undefined;
    };
    return MiningRobotsManufCenter;
}(MoonCard_1.MoonCard));
exports.MiningRobotsManufCenter = MiningRobotsManufCenter;
